import request from "~/utils/http";

const customerApi =
{
	get : async (id) =>
    {
		const url = `customer/detail/${id}`;
		return await request.get(url);
	},
	gets : async (params) =>
    {
		const url = 'customer';
		return await request.get(url, {params});
	},
	options : async (params) =>
	{
		const url = 'customer';
        const paramsWidthOption = {
            ...params,
            options: true,
        };
        return await request.get(url, {paramsWidthOption});
	},
	add : async (params) =>
    {
		const url = 'customer';
		return await request.post(url, params);
	},
	update : async (params) =>
    {
		const url = `customer/${params.id}`;
		return await request.post(url, params);
	},
	delete : async (id) =>
    {
		const url = `customer/${id}`;
		return await request.delete(url);
	},
};

export default customerApi;